import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Component } from "@contember/binding";
const Block = Component(
  (props) => /* @__PURE__ */ jsx(Fragment, { children: props.children }),
  (props) => /* @__PURE__ */ jsxs(Fragment, { children: [
    props.alternate,
    props.children
  ] }),
  "Block"
);
export {
  Block
};
//# sourceMappingURL=Block.js.map
